import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React, { useContext } from 'react';
import { AppContext, CurrencyText } from '@nile/components';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

const Wrapper = styled.div`
  ${({ alignRight }) =>
    alignRight &&
    `
    width: 100%;
    justify-content: flex-end;
  `}
`;

function EditableCell(props) {
  const { company } = useContext(AppContext);
  const currencyCode = company?.currency || 'USD';
  const countryCode = company?.countryCode || 'US';
  const { cell, intl, data } = props;
  const meta = cell?.row?.original;
  const { actions, field } = cell.column;
  let value = meta.revisedQuantity * meta.revisedUnitPrice;
  value = value
    ? Number(value) - Number(value) * (Number(meta.revisedDiscountRate) / 100)
    : '';
  const renderValue = (displayVal) => {
    if (cell?.column?.isBold) {
      return (
        <b>
          <CurrencyText value={displayVal} />
        </b>
      );
    }
    return <CurrencyText value={displayVal} />;
  };
  return (
    <Wrapper className="flex" alignRight={cell?.column?.alignRight}>
      <div>{value ? renderValue(value) : <DisabledTag>NA</DisabledTag>}</div>
    </Wrapper>
  );
}

export default injectIntl(EditableCell);
